import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'rcierror',
    templateUrl: './rci-error.component.html',
    styleUrls: ['./rci-error.component.css']
})
export class RciErrorComponent implements OnInit {
    constructor() {
    }

    @Input()
    triedSubmit:boolean;
    @Input()
    control:any;
    @Input()
    label:string;

    ngOnInit() {
    }
}
